<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    :editIcon="editIcon"
    :readOnly="readOnly"
    width="80%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :modelNameSingular="modelNameSingular"
    :isTextButton="isTextButton"
    :textButton="textButton"
  >

    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :extraData="extraData"
        id="printableELement"
        :readOnly="readOnly"
        @installment-update="loadServerEntry(entry.id)"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>   
    <!-- <template slot="action1">
      <BasePrint
        printableElementId="printableELement"
        printButtonLabel="Imprimir Prévia da Venda"
        printTitle="Prévia das Informações da Venda"
        @start-printing="pageLoading = true"
        @stop-printing="pageLoading = false"
      />
    </template> -->
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseEdit from "@shared_components/base_edit.vue";
import BasePrint from "@shared_components/base_print.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    // editTitle: {
    //   type: String,
    //   default: "Edição de Pedido de Venda"
    // },
    // readTitle: {
    //   type: String,
    //   default: "Visualização de Pedido de Venda"
    // },
    editIcon: {
      type: String,
      default: "mdi-pencil"
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    isTextButton: {
      type: Boolean,
      default: false
    },
    textButton: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit,
    BasePrint: BasePrint
  },
  created() {
    // console.log("edit sale  ordercreated");
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = null;
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_SALE_ORDER_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            id: id
          }
        })
        .then(response => {
          this.editableEntry = response.data.accountContext.saleOrder;
          this.extraData = response.data;
          // console.log("saleOrder edit", this.editableEntry);
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    updateServerEntry: function(saleOrder) {
      // console.log("saleOrder", saleOrder, saleOrder.validations, this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations));
      this.pageLoading = true;
      this.$apollo
        .mutate({
          mutation: UPDATE_SALE_ORDER_MUTATION,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(saleOrder, saleOrder.validations)
          }
        })
        .then(response => {
          var errors = response.data.updateSaleOrder.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$refs.baseEdit.closeDialog();
            this.$emit("entry-updated");
            this.resetForm();
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.pageLoading = false));
    },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.updateServerEntry(this.editableEntry)
      }
    },
    resetForm: function() {
      if (this.$refs.form) {
        this.$refs.form.resetFormInputs();
      }
      this.formErrors = [];
      this.$emit("entry-canceled");
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};

const LOAD_SALE_ORDER_QUERY = gql `
  query ($id: ID!) {
    accountContext {
      saleOrder(id: $id) {
        id
        code
        plate
        billDate
        date
        saleOrderTime
        estimatedDeliveryDate
        paymentConditionRuleId
        fiscalDocumentType
        cfopId
        orderValidity
        customerId
        totalPrice
        observation
        validations
        operationsView{
          id
          code
          operationTypeName
          planningDate
          executionDate
          clientName
          quantities
          variety
        }
        carrierId
        carrier {
          id
        }
        carriageModalityId
        carriageModality {
          id
        }
        carrierPatrimonyId
        carrierPatrimony {
          id
        }
        carrierLicensePlate
        carrierLicensePlateStateId
        totalCarriageValue
        totalDiscountValue
        totalInsuranceValue
        otherExpensesTotalValue
        dummyExitMovementItemsAttributes {
          id
          price
          quantity
          discount
          totalDiscount
          liquidPrice
          packagingQuantity
          packagingUnitName
          itemId
          storageId
          isNewItemInStorage
          unitPrice
          packagingPrice
          item {
            id
            name
            type
            brand{
              id
              name
            }
            description
            unit {
              name
            }
            packagings {
              id
              name
              size
              text
            }
          }
          storage {
            id
            name
          }
          packagingId
          packaging {
            id
            name
            size
            text
          }
        }
        paymentsAttributes {
          id
          code
          bankAccountId
          paymentMethodId
          value
          initialDate
          installmentsInterval {
            id
            description
          }
          paymentConditionId
          paymentCondition {
            id
            description
            numberOfInstallments
          }
          paymentMethod {
            id
            name
          }
          bankAccount {
            id
            name
          }
          installmentsAttributes {
            id
            value
            originalValue
            customCode
            dueDate
            code
            status
            statusKey
            statusColor
            paidAmount
            paymentDate
            bankAccount {
              id
              name
            }
          }
        }
      }
      allPaymentConditionRules{
        id
        name
      }
      allCustomers {
        id
        name
      }
      accountPermissions{
        isAltavenda
        isSeller
      }
      allCarriers {
        id
        name
      }
      allCfops{
        id
        text
      }
    }
    globalContext {
			allPaymentConditions {
        id
        description
        numberOfInstallments
      }
      allCarriageModalities {
        id
        text
      }
      allStates {
        id
        shortName
      }
    }
  }
`;

const UPDATE_SALE_ORDER_MUTATION = gql `
  mutation($input: SaleOrderUpdateInputObject!) {
    updateSaleOrder(input: $input) {
      cashFlow {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

<!-- mutation {
  updateSale(
    id: 2,
    customerId: 3,
    deliveryDate: "2020-01-31",
    saleProductsAttributes: [
      {id: 4, price: 1, quantity: 1, itemId: 14, storehouseId: 3, _destroy: true},
      {price: 10, quantity: 1, itemId: 14, storehouseId: 3}
    ],
    paymentsAttributes: [
      {id: 4, value: 10, numberOfInstallments: 1, initialDate:"2020-01-31", bankAccountId: 1, paymentMethodId: 16}
    ]
  ){
    cashFlow {
      id
    }
    errors
  }
} -->
